import {
    Document,
    Page,
    Text,
    View,
    StyleSheet,
    Font,
    PDFViewer,
    Image,
    usePDF
} from "@react-pdf/renderer";
import { useEvent } from "../context/eventContext";
import { myTimestampToDate, propComparator } from "../utils/ui_utils";
import { format } from "date-fns";
import { Button, ButtonGroup, CircularProgress, Grid2 as Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { getCross } from "../definitions/cow";
import { logopath } from "../definitions/anafilogo";
import { Download } from "@mui/icons-material";

Font.register(
    {
        family: 'Ubuntu',
        fonts: [
            {
                src: 'https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf',
            },
        ],
    },
)
Font.register(
    {
        family: 'Ubuntu-bold',
        fonts: [
            {
                src: 'https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf',
            },
        ],
    },
)
Font.register(
    {
        family: 'Ubuntu-italic',
        fonts: [
            {
                src: 'https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf',
            },
        ],
    },
);

const style_common = StyleSheet.create({
    page: {
        backgroundColor: "#fff",
        color: "black",
        margin: 0,
        marginVertical:20,
        fontFamily: "Ubuntu",
        padding: 0,
    },
    viewer: {
        width: window.innerWidth - 100, //the pdf viewer will take up all of the width and height
        height: window.innerHeight - 200,
    },

})

// Create styles
const style_signboard = StyleSheet.create({
    page: {
        backgroundColor: "#fff",
        color: "black",
        margin: 10,
        fontFamily: "Ubuntu",
        padding: 10,
    },
    section: {
        margin: 0,
        padding: 10,
    },
    header: {
        padding: 10,
        flexDirection: "row",
        borderBottom: '2px solid black',
        justifyContent: "center",
        verticalAlign: "center"
    },
    catalog: {
        fontSize: '80px',
        textAlign: "center",
        fontFamily: "Ubuntu-bold",
        flex: 1
    },
    birth: {
        color: 'grey',
        fontSize: "20px",
        textAlign: 'center',
        marginTop: 10,
        flex: 1,
        alignSelf: 'center'
    },
    hightlight: {
        color: 'black',
        fontSize: "30px",
        fontWeight: 'bold'
    },
    image: {
        height: 70,
        marginHorizontal: 4,
        alignSelf: 'center',
    },
    cow_container: {
        border: '2px solid black',
        width: '95%',
        height: '94%',
        padding: 10,
        borderRadius: 20
    },
    subsection: {
        margin: 10,
        padding: 10,
    },
    firstrow: {
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: "center",
        fontSize: '40px',
        borderBottom: '2px solid black',
        fontFamily: "Helvetica-Bold",
    },
    secondrow: {
        display: 'flex',
        flex: 1,
        borderBottom: '2px solid black',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '30px'
    },
    thirdrow: {
        display: 'flex',
        flex: 2,
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '30px'
    },
    smallFont: {
        fontSize: '22px'
    },
    toprow: {
        display: 'flex',
        flex: 0.2,
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '10px'
    },
});


// Create styles
const style_number = StyleSheet.create({
    header: {
        padding: 5,
        marginTop: 10,
        flexDirection: "row",
        justifyContent: "center",
        verticalAlign: "center"
    },
    catalog: {
        fontSize: '280px',
        marginTop: -40,
        color: 'black',
        overflow: 'hidden',
        fontFamily: "Helvetica-Bold",
    },

    image: {
        height: 70,
        marginRight: 10,
        marginLeft: 10,
        alignSelf: 'center',
    },
    cow_container: {
        border: '2px solid black',
        width: '18cm',
        height: '11cm',
        marginTop: 0,
        borderRadius: 20
    },
});


const perChunk = 50

const SingleCowPdf = ({ cow_list, type, showPreview }) => {
    const { selEvent } = useEvent()
    const [chunk_index, setChunkIndex] = useState(0)
    const [chunk_list, setChunkList] = useState([])
    const [instance, update] = usePDF({ document: <MyDoc type={type} cow_list={cow_list} selEvent={selEvent} Element={(props) => type === 'signboard' ? <OneCowSignboard {...props} /> : <OneCowNumber {...props} />} /> });
    const [viewPreview, setViewPreview] = useState(false)
    useEffect(() => {
        setViewPreview(false)
        //setViewPreview(cow_list.length === 1)
    }, [])


    const label = type === 'signboard' ? 'cartelli' : 'pettorali'

    useEffect(() => {
        console.log("UPDATE LIST", chunk_list[chunk_index])
        if (type === 'signboard') {

            update(
                <MyDoc cow_list={chunk_list[chunk_index]} type={type} selEvent={selEvent} Element={(props) => <OneCowSignboard {...props} />} />)
        } else {
            update(
                <MyDoc cow_list={chunk_list[chunk_index]} type={type} selEvent={selEvent} Element={(props) => <OneCowNumber {...props} />} />)
        }
    }, [chunk_index, chunk_list])

    useEffect(() => {
        if (cow_list && cow_list.length > 0) {
            console.log("cow_list", cow_list)
            const inputArray = cow_list.sort(propComparator('catalog_id'))
            const _chunk_list = inputArray.reduce((resultArray, item, index) => {
                const chunkIndex = Math.floor(index / perChunk)

                if (!resultArray[chunkIndex]) {
                    resultArray[chunkIndex] = [] // start a new chunk
                }

                resultArray[chunkIndex].push(item)

                return resultArray
            }, [])
            console.log("NEW CHUNK", _chunk_list)
            setChunkList(_chunk_list)
            setChunkIndex(0)
        }
    }, [cow_list])

    const getFilename = () => {
        let filename = `${selEvent.event_name}-${label} soggetti (soggetti da 1 a${cow_list.length}).pdf`

        if (cow_list.length === 1) {
            filename = `${selEvent.event_name}-${label} (soggetto ${cow_list[0].catalog_id}).pdf`
        }
        if (chunk_list[chunk_index]) {
            filename = `${selEvent.event_name}-${label} soggetti (soggetti da ${1 + (perChunk * chunk_index)} - ${(perChunk * chunk_index) + chunk_list[chunk_index].length}).pdf`
        }
        return filename
    }

    return (
        <>
            <Grid container>
                <Grid>
                    <ButtonGroup>
                        {chunk_list.map((c, k) => (
                            <Button variant={chunk_index === k ? "contained" : "outlined"} onClick={() => setChunkIndex(k)} key={k}>soggetti {1 + (perChunk * k)}- {(perChunk * k) + c.length}</Button>
                        ))}
                    </ButtonGroup>
                </Grid>
                <Grid size="grow" sx={{ textAlign: "center" }}>
                    {viewPreview ?
                        <Button variant="outlined" onClick={() => setViewPreview(p => !p)}>Nascondi preview prima pagina</Button>
                        :
                        <Button variant="outlined" onClick={() => setViewPreview(p => !p)}>Visualizza preview prima pagina</Button>
                    }
                </Grid>
            </Grid>
            {instance.error && <div>C'è stato qualche problema: {instance.error}</div>}
            {instance.loading && <div>Caricamento pdf in corso ...<CircularProgress /></div>}
            {!instance.loading && !instance.error ?
                <>
                    <Button color="secondary" variant="contained" href={instance.url} download={getFilename()} startIcon={<Download />}>Scarica pdf </Button>
                </>
                : <></>}
            {viewPreview &&
                <PDFViewer style={style_signboard.viewer} showToolbar={false}>
                    <MyDocPreview cow_list={[cow_list[0]]} selEvent={selEvent} type={type} Element={(props) => type === 'signboard' ? <OneCowSignboard {...props} /> : <OneCowNumber {...props} />} />
                </PDFViewer>
            }
        </>
    )
}



// Create Document Component
const MyDocPreview = ({ cow_list, selEvent, Element, type }) => {
    return (
        <Document >
            <Page size="A4" style={style_common.page} orientation={type === "signboard" ? "landscape" : "portrait"}>
                {cow_list?.map((c, k) => (
                    <Element key={k} cow={c} index={k} selEvent={selEvent} />
                ))}
            </Page>
        </Document>
    );
}
// Create Document Component
const MyDoc = ({ cow_list, selEvent, Element, type }) => {
    return (
        <Document>
            <Page size="A4" style={style_common.page} orientation={type === "signboard" ? "landscape" : "portrait"}>
                {cow_list?.map((c, k) => (
                    <Element key={k} cow={c} index={k} selEvent={selEvent} />
                ))}
            </Page>
        </Document>
    )

}


const OneCowSignboard = ({ cow, index, selEvent }) => {
    let property_string = cow.property?.name || ''
    if (cow.property && cow.property.provincia && cow.property.provincia.length > 0) {
        property_string = property_string + " - " + cow.property.provincia
    }

    return (

        <View break={index !== 0} style={style_signboard.cow_container}>
            <View style={style_signboard.toprow}>
                <Text>{selEvent?.event_name}</Text>
            </View>
            <View style={style_signboard.header}>
                <View style={style_signboard.birth}>
                    <View style={{ flexDirection: 'row', justifyContent: "center" }}>
                        {selEvent.signboard_show_logo ?
                            <Image
                                style={style_signboard.image}
                                src={logopath}
                            />
                            : <></>
                        }
                        {selEvent.signboard_show_customlogo && selEvent.logo ?
                            <Image
                                style={style_signboard.image}
                                src={selEvent.logo}
                            />
                            : <></>
                        }
                    </View>
                </View>
                <View style={style_signboard.catalog}><Text>{cow.catalog_id}</Text>
                </View>
                <View style={style_signboard.birth}>
                    <View>
                        <Text>Nata il</Text>
                    </View>
                    <Text style={style_signboard.hightlight}>{format(myTimestampToDate(cow.birthdate), 'dd/MM/yyyy')}</Text>
                </View>
            </View>
            <View style={style_signboard.firstrow}>
                <Text>
                    {cow.name}
                </Text>
            </View>
            <View style={style_signboard.secondrow}>
                <Text>
                    {getCross(cow)}
                </Text>
            </View>
            <View style={style_signboard.thirdrow}>
                <Text>
                    {property_string}
                </Text>
                <Text style={style_signboard.smallFont}>
                    {cow.coproperty}
                </Text>
            </View>
        </View>

    )
}


const OneCowNumber = ({ cow, index, selEvent }) => (

    <View style={{ textAlign: 'center', alignItems: "center", height: '100%' }}>

        <View style={style_number.cow_container}>
            <View style={style_number.header}>
                {selEvent.number_show_logo ?
                    <Image
                        style={style_number.image}
                        src={logopath}
                    />
                    : <></>
                }
                {selEvent.number_show_customlogo && selEvent.logo ?
                    <Image
                        style={style_number.image}
                        src={selEvent.logo}
                    />
                    : <></>
                }
            </View>
            <View style={style_number.catalog}>
                <Text>{cow.catalog_id}</Text>
            </View>
        </View>
        <View style={style_number.cow_container}>
            <View style={style_number.header}>
                {selEvent.number_show_logo ?
                    <Image
                        style={style_number.image}

                        src={logopath}
                    />
                    : <></>
                }
                {selEvent.number_show_customlogo && selEvent.logo ?
                    <Image
                        style={style_number.image}
                        src={selEvent.logo}
                    />
                    : <></>
                }
            </View>
            <View style={style_number.catalog}>
                <Text>{cow.catalog_id}</Text>
            </View>
        </View>


    </View>

)





export default SingleCowPdf;